import apiClient from "./client";

export const getAdminProjects = async () => {
  const response = await apiClient.get("/projects/admin");
  return response.data;
};

export const createAdminProject = async (payload) => {
  const response = await apiClient.post("/projects/admin", payload);
  return response.data;
};

export const updateAdminProject = async ({ id, payload }) => {
  const response = await apiClient.put(`/projects/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminProject = async ({ id }) => {
  await apiClient.delete(`/projects/admin/${id}`);
};

export const uploadAdminProjectImage = async ({ id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/projects/admin/${id}/images`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const removeAdminProjectImage = async ({ id, imageId }) => {
  const response = await apiClient.delete(`/projects/admin/${id}/images/${imageId}`);
  return response.data;
};
